import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'

import App from './App.vue'
import router from './router'
import { syncServerTime } from './utils/serverTime'

// Styles PrimeVue
import 'primevue/resources/themes/saga-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'

// Nouveau thème moderne HMO
import './assets/styles/theme.css'

// Styles globaux hospitaliers
import './styles/hospital-theme.css'

// Thème global partagé des modals
import './styles/modal-theme.css'

// Composants PrimeVue globaux
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Password from 'primevue/password'
import Card from 'primevue/card'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
import Dialog from 'primevue/dialog'
import Dropdown from 'primevue/dropdown'
import Calendar from 'primevue/calendar'
import Textarea from 'primevue/textarea'
import Checkbox from 'primevue/checkbox'
import RadioButton from 'primevue/radiobutton'
import ProgressBar from 'primevue/progressbar'
import Badge from 'primevue/badge'
import Chip from 'primevue/chip'
import Menu from 'primevue/menu'
import Menubar from 'primevue/menubar'
import Sidebar from 'primevue/sidebar'
import Toolbar from 'primevue/toolbar'
import FileUpload from 'primevue/fileupload'
import Image from 'primevue/image'
import InputNumber from 'primevue/inputnumber'
import InputSwitch from 'primevue/inputswitch'
import ProgressSpinner from 'primevue/progressspinner'
import Tag from 'primevue/tag'
import Message from 'primevue/message'
import Tooltip from 'primevue/tooltip'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'

const app = createApp(App)

// Pinia store
const pinia = createPinia()
app.use(pinia)

// Router
app.use(router)

// PrimeVue
app.use(PrimeVue)
app.use(ToastService)
app.use(ConfirmationService)

// Composants globaux
app.component('Button', Button)
app.component('InputText', InputText)
app.component('Password', Password)
app.component('Card', Card)
app.component('DataTable', DataTable)
app.component('Column', Column)
app.component('Toast', Toast)
app.component('ConfirmDialog', ConfirmDialog)
app.component('Dialog', Dialog)
app.component('Dropdown', Dropdown)
app.component('Calendar', Calendar)
app.component('Textarea', Textarea)
app.component('Checkbox', Checkbox)
app.component('RadioButton', RadioButton)
app.component('ProgressBar', ProgressBar)
app.component('Badge', Badge)
app.component('Chip', Chip)
app.component('Menu', Menu)
app.component('Menubar', Menubar)
app.component('Sidebar', Sidebar)
app.component('Toolbar', Toolbar)
app.component('FileUpload', FileUpload)
app.component('Image', Image)
app.component('InputNumber', InputNumber)
app.component('InputSwitch', InputSwitch)
app.component('ProgressSpinner', ProgressSpinner)
app.component('Tag', Tag)
app.component('Message', Message)
app.component('TabView', TabView)
app.component('TabPanel', TabPanel)
app.directive('tooltip', Tooltip)
app.directive('click-outside', {
  mounted(el, binding) {
    el._clickOutsideHandler = (e: MouseEvent) => { if (!el.contains(e.target as Node)) binding.value(e) }
    document.addEventListener('click', el._clickOutsideHandler, true)
  },
  unmounted(el) { document.removeEventListener('click', el._clickOutsideHandler, true) },
})

// Synchronisation horloge serveur (correction du décalage client)
syncServerTime()

app.mount('#app')